<script>
    import PriceControl from "../components/controls/PriceControl.svelte";
    import CaretIcon from "../components/icons/CaretIcon.svelte";

    export let shift;

    let showData = false;

    const setTotals = () => {
        const expenses =  [
            'fuel',
            'laundry',
            'food',
            'service',
            'misc',
        ];

        const types = [
            'on_account', 'cash'
        ];

        shift.total_expenses = 0;

        types.map(type => {
            let total = 0;
            expenses.map(key => {
                total += parseFloat(shift.expenses[type][key] || 0);
            });
            shift.total_expenses+= total;
            shift.expenses[type].total = total > 0 ? total.toFixed(2) : null;
        });
    }

    $: setTotals();
</script>

<div class="legend py-1 mb-2">
    <button class="btn no-outline d-flex align-items-center justify-content-between w-100 px-0 fs-6"
            on:click={() => showData = !showData}>
        Expenses
        <span class="d-flex align-items-center gap-2">
            {#if shift.total_expenses > 0}
                <span class="text-gray">{shift.total_expenses}€</span>
            {/if}
            <CaretIcon size="18" strokeWidth="2" expanded={showData}/>
        </span>
    </button>
</div>
{#if showData}
    <table class="table totals mb-4">
        <thead>
        <tr>
            <th>Expenses</th>
            <th>On Account</th>
            <th>Cash</th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td>Fuel</td>
            <td>
                <PriceControl cssClass="small-input" bind:value={shift.expenses.on_account.fuel} onChange={setTotals}/>
            </td>
            <td>
                <PriceControl cssClass="small-input" bind:value={shift.expenses.cash.fuel} onChange={setTotals}/>
            </td>
        </tr>
        <tr>
            <td>Laundry</td>
            <td>
                <PriceControl cssClass="small-input" bind:value={shift.expenses.on_account.laundry} onChange={setTotals}/>
            </td>
            <td>
                <PriceControl cssClass="small-input" bind:value={shift.expenses.cash.laundry} onChange={setTotals}/>
            </td>
        </tr>
        <tr>
            <td>Food/Beverage</td>
            <td>
                <PriceControl cssClass="small-input" bind:value={shift.expenses.on_account.food} onChange={setTotals}/>
            </td>
            <td>
                <PriceControl cssClass="small-input" bind:value={shift.expenses.cash.food} onChange={setTotals}/>
            </td>
        </tr>
        <tr>
            <td>Service</td>
            <td>
                <PriceControl cssClass="small-input" bind:value={shift.expenses.on_account.service} onChange={setTotals}/>
            </td>
            <td>
                <PriceControl cssClass="small-input" bind:value={shift.expenses.cash.service} onChange={setTotals}/>
            </td>
        </tr>
        <tr>
            <td>Misc</td>
            <td>
                <PriceControl cssClass="small-input" bind:value={shift.expenses.on_account.misc} onChange={setTotals}/>
            </td>
            <td>
                <PriceControl cssClass="small-input" bind:value={shift.expenses.cash.misc} onChange={setTotals}/>
            </td>
        </tr>
        <tr>
            <td>Total</td>
            <td class="no-input">{shift.expenses.on_account.total || ''}</td>
            <td class="no-input">{shift.expenses.cash.total || ''}</td>
        </tr>
        </tbody>
    </table>
{/if}